"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _utils = require("./utils");
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unknown-property */
var styles = {
  "wrapper": "wrapper_1oqj0O"
}; 
require('./ResultsLoading.css');
const CellLoader = ({
  min,
  max,
  height = 18
}) => {
  const width = (0, _utils.getRandomInteger)(min, max);
  return /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    height: height,
    viewBox: `0 0 ${max} 20`
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: width,
    height: 20
  }));
};
const Loading = props => {
  const {
    headers,
    additionalColumnsCount
  } = props;
  const labels = headers.map(header => ({
    label: header.label
  }));
  const originalHeadersCount = headers.length - (additionalColumnsCount !== null && additionalColumnsCount !== void 0 ? additionalColumnsCount : 0);
  const statusCell = props.hideStatusCell ? null : /*#__PURE__*/_react.default.createElement(CellLoader, {
    key: "status",
    min: 60,
    max: 100,
    height: 23
  });
  return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Table, {
    headers: labels,
    testId: "search-results-loading"
  }, [0, 1, 2, 3, 4].map(index => /*#__PURE__*/_react.default.createElement("tr", {
    key: index
  }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(CellLoader, {
    min: 100,
    max: 280
  })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/_react.default.createElement(CellLoader, {
    key: "version",
    min: 50,
    max: 60
  }), "\xA0", statusCell)), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(CellLoader, {
    min: 70,
    max: 90
  })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(CellLoader, {
    min: 70,
    max: 80
  })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(CellLoader, {
    min: 70,
    max: 100
  })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(CellLoader, {
    min: 70,
    max: 110
  })), headers.slice(originalHeadersCount).map((header, headerIndex) => /*#__PURE__*/_react.default.createElement("td", {
    key: headerIndex
  })))));
};
var _default = exports.default = Loading;
//# sourceMappingURL=ResultsLoading.js.map